import React from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { TVendorStatus, VendorChangeTicketsApiResponse } from '../../../types/vendor-types';

interface UseGetChangeTicketsParams {
  status: TVendorStatus;
  limit?: number;
  offset?: number;
  documentReviewed?: boolean;
  organization?: string;
  document?: string;
  extractionBatch?: string;
  dataPool?: string;
  normalizedVendorName?: string;
  enabled?: boolean;
}

const useGetChangeTickets = ({
  status,
  limit = 10,
  offset = 0,
  documentReviewed,
  organization,
  document,
  extractionBatch,
  dataPool,
  normalizedVendorName,
  enabled,
}: UseGetChangeTicketsParams) => {
  const glynt = useGlynt();

  return useQuery({
    queryKey: [
      'vendor-change-tickets',
      status,
      limit,
      offset,
      documentReviewed,
      organization,
      document,
      extractionBatch,
      dataPool,
      normalizedVendorName,
    ],

    queryFn: async () => {
      return (await glynt).vendor.changeTickets({
        status,
        limit,
        offset,
        // Only include document_reviewed if it's explicitly set (not undefined)
        ...(documentReviewed !== undefined && { document_reviewed: documentReviewed }),
        organization,
        document,
        extraction_batch: extractionBatch,
        data_pool: dataPool,
        normalized_vendor_name: normalizedVendorName,
      });
    },

    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    ...(enabled !== undefined && { enabled })
  });
};

export default useGetChangeTickets;
